import React from 'react';
import { Link as LinkRouter } from 'react-router-dom';
import '../Css/Card.css';
import CarouselCard from './CarouselCard';
import { FaHome, FaRulerCombined } from 'react-icons/fa';

function PropertyCard({ property, tiposPropiedad }) {
  const getCurrencySymbol = (currency) => (currency === 'ARS' ? '$' : 'USD');

  const tipoPropiedadNombre =
    tiposPropiedad?.find((t) => t._id === property.tipoPropiedad)?.nombre ||
    'Tipo no especificado';

  // === NUEVO: priorizamos m2Totales y fallback a metrosCuadrados ===
  const metros =
    Number(property?.caracteristicas?.m2Totales) > 0
      ? Number(property.caracteristicas.m2Totales)
      : Number(property?.caracteristicas?.metrosCuadrados) > 0
      ? Number(property.caracteristicas.metrosCuadrados)
      : null;

  const ambientes = Number(property?.caracteristicas?.ambientes) || 0;

  return (
    <li className="property-card">
      <div className="prop-img">
        <CarouselCard images={property.fotos} />

        {/* Solo metros */}
        {metros && ambientes === 0 && (
          <div className="prop-data full-width">
            <FaRulerCombined /> {metros} m²
          </div>
        )}

        {/* Metros + ambientes */}
        {metros && ambientes > 0 && (
          <>
            <div className="prop-data">
              <FaRulerCombined /> {metros} m²
            </div>
            <div className="prop-data2">
              <FaHome /> {ambientes}
            </div>
          </>
        )}
      </div>

      <div className="card-details">
        {tipoPropiedadNombre} en {property.estado} en {property.ubicacion}
      </div>

      <div className="prop-desc-dir">{property.direccion}</div>

      {property.precio > 0 && (
        <div className="prop-valor-nro">
          {getCurrencySymbol(property.moneda)} {property.precio}
        </div>
      )}

      <div className="details-button">
        <LinkRouter to={`/Pages/PropertyDetails/${property._id}`} className="ver-ficha-box">
          <div className="prop-img-bg animated fadeIn">
            <div className="ver-ficha-box animated fadeInUp">VER DETALLES</div>
          </div>
        </LinkRouter>
      </div>
    </li>
  );
}

export default PropertyCard;
